/**
 * @generated SignedSource<<b525fe9a558cb53df4df77f2ae34a2bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSetFocusScrollMutation$variables = {
  storecastId: string;
  topItemId: string;
  widgetId: string;
};
export type useSetFocusScrollMutation$data = {
  readonly dashboard: {
    readonly setFocusScroll: string;
  };
};
export type useSetFocusScrollMutation = {
  response: useSetFocusScrollMutation$data;
  variables: useSetFocusScrollMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topItemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "topItemId",
            "variableName": "topItemId"
          },
          {
            "kind": "Variable",
            "name": "widgetId",
            "variableName": "widgetId"
          }
        ],
        "kind": "ScalarField",
        "name": "setFocusScroll",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetFocusScrollMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSetFocusScrollMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d5466532712670007db4abaf6f780578",
    "id": null,
    "metadata": {},
    "name": "useSetFocusScrollMutation",
    "operationKind": "mutation",
    "text": "mutation useSetFocusScrollMutation(\n  $topItemId: ID!\n  $storecastId: ID!\n  $widgetId: ID!\n) {\n  dashboard(dashboardId: $storecastId) {\n    setFocusScroll(topItemId: $topItemId, widgetId: $widgetId)\n  }\n}\n"
  }
};
})();

(node as any).hash = "d62a1230ffa0b01498635d71723bb277";

export default node;
